import { colors, ThemeOptions } from "@mui/material";

const palette: Exclude<ThemeOptions["palette"], undefined> = {
  background: {
    default: "#f5f6f8",
    paper: colors.common.white,
  },
  primary: {
    main: "#00205C",
  },
  secondary: {
    main: "#00B189",
    contrastText: "#ffffff",
  },
  error: {
    main: "#FE5E5B",
  },
  action: {
    active: "#F93549",
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
  },
};

export default palette;
